import { z } from 'zod'

export const MailAccountType = z.enum(['mailbox', 'alias', 'list', 'group', 'admin', 'domain_admin'])
export type MailAccountType = z.infer<typeof MailAccountType>

export const MailAccount = z.object({
  id: z.number(),
  type: MailAccountType,
  email: z.string(),
  description: z.string().nullable().optional(),
  active: z.boolean(),
  quota_bytes: z.number().optional(),
  used_bytes: z.number().optional(),
  usage_percent: z.number().optional(),
  targets: z.array(z.string()).optional(),
  members: z.array(z.string()).optional(),
  external_members: z.array(z.string()).optional(),
  created_at: z.string(),
  updated_at: z.string(),
  domain_id: z.number(),
  domain_name: z.string().optional(),
  last_login: z.string().nullable().optional()
})

export type MailAccount = z.infer<typeof MailAccount>

export const CreateMailboxRequest = z.object({
  name: z.string(),
  domain_id: z.number(),
  type: z.literal('mailbox'),
  password: z.string(),
  quota_bytes: z.number().optional(),
  sender_addresses: z.array(z.string()).optional()
})

export type CreateMailboxRequest = z.infer<typeof CreateMailboxRequest>

export const CreateAliasRequest = z.object({
  name: z.string(),
  domain_id: z.number(),
  type: z.literal('alias'),
  alias_targets: z.array(z.string())
})

export type CreateAliasRequest = z.infer<typeof CreateAliasRequest>

export const CreateMailingListRequest = z.object({
  name: z.string(),
  domain_id: z.number(),
  type: z.literal('list'),
  members: z.array(z.string()).optional(),
  external_members: z.array(z.string()).optional()
})

export type CreateMailingListRequest = z.infer<typeof CreateMailingListRequest>

export const CreateSharedMailboxRequest = z.object({
  name: z.string(),
  domain_id: z.number(),
  type: z.literal('shared'),
  quota_bytes: z.number().optional(),
  members: z.array(z.string()).optional()
})

export type CreateSharedMailboxRequest = z.infer<typeof CreateSharedMailboxRequest>

export const CreateMailAccountRequest = z.discriminatedUnion('type', [
  CreateMailboxRequest,
  CreateAliasRequest,
  CreateMailingListRequest,
  CreateSharedMailboxRequest
])

export type CreateMailAccountRequest = z.infer<typeof CreateMailAccountRequest>

export const UpdateMailAccountRequest = z.object({
  active: z.boolean().optional(),
  quota_bytes: z.number().optional(),
  targets: z.array(z.string()).optional(),
  members: z.array(z.string()).optional(),
  external_members: z.array(z.string()).optional()
})

export type UpdateMailAccountRequest = z.infer<typeof UpdateMailAccountRequest>

export const ChangePasswordRequest = z.object({
  password: z.string()
})

export type ChangePasswordRequest = z.infer<typeof ChangePasswordRequest>
